import { useContent } from '../../contexts/ContentContext'
import SectionWrapper from '../ui/SectionWrapper'
import LazyImage from '../ui/LazyImage'

export default function WelcomeSection() {
  const { welcome } = useContent()

  return (
    <SectionWrapper data-section="WelcomeSection" id="welcome" data-testid="welcome-section">
      <div className="grid md:grid-cols-[300px_1fr] lg:grid-cols-[340px_1fr] card-grid-gap-sm md:card-grid-gap-lg items-start">

        {/* Left: Portrait + Greeting — shown after greeting on mobile, first on desktop */}
        <div className="flex flex-col items-center md:items-start gap-4 sm:gap-6 md:gap-6 order-1 md:order-1 md:sticky md:top-28 md:self-start">
          {/* Mobile-optimized portrait sizes — desktop uses larger fixed size */}
          <div className="w-4/5 h-4/5 max-w-[240px] max-h-[240px] sm:w-3/4 sm:h-3/4 sm:max-w-[280px] sm:max-h-[280px] md:w-[320px] md:h-[320px] lg:w-[340px] lg:h-[340px] rounded-full overflow-hidden flex-shrink-0 border border-color-primary order-2 md:order-1">
            <LazyImage
              src={welcome.imageUrl}
              alt={welcome.author}
              className="w-full h-full object-cover object-top scale-[1.03]"
            />
          </div>

          {/* Greeting — shown first on mobile, below photo on desktop */}
          <div className="order-1 md:order-2 text-center md:text-left">
            <p className="typography-handwriting whitespace-pre-line">
              {welcome.headline}
            </p>
          </div>
        </div>

        {/* Right: Body text + signature */}
        <div className="flex flex-col justify-center min-w-0 order-2 md:order-2 mt-6 md:mt-0">
          <span
            className="typography-hero-mobile md:typography-hero-large leading-none block mb-0 select-none hidden md:block"
            aria-hidden="true"
          >
            "
          </span>

          {/* Mobile-optimized quote spacing */}
          <div className="space-y-3 sm:space-y-4 md:space-y-5 -mt-4">
            {welcome.quoteLines.map((line, i) => (
              <p key={i} className="typography-quote-featured-mobile md:typography-quote-featured">
                {line}
              </p>
            ))}
          </div>

          {/* Signature — handwriting text */}
          <div className="mt-2">
            <p className="typography-handwriting">
              {welcome.author}
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>
  )
}
